import React from "react";
import { LuPrinter } from "react-icons/lu";

// Printer icon tile: green when the printer is online, grey when offline or unknown.
export function PrinterTile({ online }) {
  return (
    <span
      className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-xl ${
        online ? "bg-green-50 text-green-600" : "bg-gray-100 text-gray-400"
      }`}
    >
      <LuPrinter className="h-6 w-6" aria-hidden="true" />
    </span>
  );
}

export function StatusDot({ online, children }) {
  return (
    <span className="flex items-center gap-1.5 text-sm text-gray-500">
      <span
        className={`h-2 w-2 rounded-full ${online ? "bg-green-500" : "bg-gray-400"}`}
        aria-hidden="true"
      />
      {children}
    </span>
  );
}

export const printerStatusLabel = (printer) =>
  printer.status || (printer.isAvailable ? "Online" : "Offline");
